import { SelectOption } from 'components/inputs/BaseSelect';
import { FeatureFlag, useFeatureFlags } from 'featureFlags';

export const useLanguageOptions = () => {
  const { [FeatureFlag.ESFRTranslations]: isESFRTranslationsEnabled } =
    useFeatureFlags();

  const existingLanguages: Record<string, Array<string>> = {
    'de-DE': ['Deutsch', '(DE)'],
    'en-AU': ['English', '(AUS)'],
    'en-GB': ['English', '(UK)'],
    'en-US': ['English', '(US)'],
    'sv-SE': ['Svenska', '(SE)'],
  };

  const featuredLanguages: Record<string, Array<string>> = {
    'sp-ES': ['Spanish', '(ES)'],
    'fr-FR': ['French', '(FR)'],
  };

  // Merge languages based on the feature flag
  const mergedLanguages = isESFRTranslationsEnabled
    ? { ...existingLanguages, ...featuredLanguages }
    : existingLanguages;

  const languageOptions = Object.entries(mergedLanguages).map(
    (language): SelectOption => ({
      label: language[1][0],
      description: language[1][1],
      value: language[0],
    })
  );

  return { languageOptions };
};
